export function normalizeClientEmail(value) {
  return String(value == null ? "" : value)
    .trim()
    .toLowerCase();
}

export function findUniqueEmailClient(orderEmail, clients) {
  const email = normalizeClientEmail(orderEmail);
  if (!email) return null;

  const matches = (Array.isArray(clients) ? clients : []).filter(
    (client) => normalizeClientEmail(client.contacto_correo) === email
  );

  return matches.length === 1 ? matches[0] : null;
}
